import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Helmet } from 'react-helmet-async';
import { FaPlus } from 'react-icons/fa';
import heroTechRecycling from '../assets/hero-tech-recycling.jpg';
import heroTechRecyclingMobile from '../assets/compressed/mobile/hero-tech-recycling.jpg';
import heroTechRecyclingTablet from '../assets/compressed/tablet/hero-tech-recycling.jpg';
import './TechRecycling.css';
import ForumDiscussion from '../components/Forum/ForumDiscussion';
import NouvDiscModal from '../components/Forum/NouvDiscModal';
import useForumPagination from '../hooks/useForumPagination';

const TechRecycling = () => {
    const [showModal, setShowModal] = useState(false);
    const { currentUser } = useAuth();
    const {
        discussions,
        loading,
        hasMore,
        loadMore,
        refreshDiscussions
    } = useForumPagination('tech-recycling-discussions');

    return (
        <main className="tech-recycling-page">
            <Helmet>
                <title>Recyclage Tech - Tech Passion</title>
                <meta name="description" content="Découvrez comment recycler vos appareils électroniques : smartphones, ordinateurs, tablettes. Guide complet sur le recyclage responsable, la réduction des déchets électroniques et l'économie circulaire tech." />
                <link rel="canonical" href="https://techpassion.fr/recyclage-tech" />
                <meta name="keywords" content="recyclage tech, déchets électroniques, e-waste, économie circulaire, recyclage électronique, réparation tech, développement durable, environnement technologie" />
                <meta property="og:title" content="Recyclage Tech - Tech Passion" />
                <meta property="og:description" content="Apprenez à recycler vos appareils électroniques de manière responsable. Solutions et conseils pour un impact environnemental positif." />
                <meta property="og:url" content="https://techpassion.fr/recyclage-tech" />
                <meta property="og:type" content="website" />
            </Helmet>

            <section className="hero">
                <div className="hero-left">
                    <div className="hero-content">
                        <h1>Recyclage Tech</h1>
                        <p>Découvrez les solutions innovantes pour recycler et valoriser les déchets électroniques</p>
                    </div>
                </div>
                <img 
                    className="hero-image"
                    src={heroTechRecycling}
                    srcSet={`${heroTechRecyclingMobile} 480w, ${heroTechRecyclingTablet} 768w, ${heroTechRecycling} 1024w`}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    alt="Centre de recyclage technologique avec tri automatisé et processus de récupération des matériaux"
                    loading="lazy"
                />
            </section>

            <section className="discussions-section">
                {loading ? (
                    <div className="loading">Chargement des discussions...</div>
                ) : (
                    <div className="discussions-container">
                        {discussions.map(discussion => (
                            <ForumDiscussion
                                key={discussion.id}
                                discussion={discussion}
                                collectionName="tech-recycling-discussions"
                                onReply={refreshDiscussions}
                            />
                        ))}
                    </div>
                )}

                {hasMore && (
                    <div className="load-more-container">
                        <button 
                            className="load-more-btn"
                            onClick={loadMore}
                        >
                            Voir plus
                        </button>
                    </div>
                )}
            </section>

            {currentUser && (
                <button 
                    className="new-discussion-button" 
                    title="Nouvelle discussion"
                    onClick={() => setShowModal(true)}
                >
                    <FaPlus />
                </button>
            )}

            <NouvDiscModal 
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                forumId="tech-recycling-discussions"
                onDiscussionUpdate={refreshDiscussions}
            />
        </main>
    );
};

export default TechRecycling;
